module.exports = __webpack_public_path__ + "images/3-hf94269a6dbc65bcfa0e5504f2727bb13.svg";